import Section from "./layouts/Section";
import {Box, Button, Typography} from "@mui/material";
import {AdvancedMarker, APIProvider, InfoWindow, Map} from "@vis.gl/react-google-maps";
import SocialMenu from "./_atoms/SocialMenu";
import ScrollAnimation from "react-animate-on-scroll";
import {useTranslations} from "../store/LanguageProvider";
import docRep from "../resources/file/OPENDOT.pdf";

const Contacts = () => {
    const {translations} = useTranslations();

    const mapPosition = {lat: 40.01842, lng: 18.23956}

    return <Section title={translations.contacts_title} id='contacts'>
        <ScrollAnimation animateIn='fadeIn'>
            <Typography variant='body1' textAlign='left'>
                {translations.contacts_desc}
            </Typography>
        </ScrollAnimation>
        <ScrollAnimation animateIn='fadeIn'>
            <Typography variant='h6' mt={3} mb={1} fontWeight='bold'>{translations.contact_us}</Typography>
        </ScrollAnimation>
        <SocialMenu />
        <ScrollAnimation animateIn='fadeIn'>
            <Typography variant='h6' mt={3} mb={1} fontWeight='bold'>{translations.wait_for_you}</Typography>
        </ScrollAnimation>
        <ScrollAnimation animateIn='fadeIn'>
            <APIProvider apiKey="AIzaSyAowTJ0St4rJVglZDVcyD3AZ4WG6AHS1wM" libraries={['marker']}>
                <Map
                    mapId={'bf47cc17014beb32'}
                    style={{height: 400}}
                    defaultCenter={mapPosition}
                    defaultZoom={18}
                    fullscreenControl={false}
                    zoomControl={false}
                    streetViewControl={false}
                    mapTypeControl={false}
                    draggable={false}
                >
                    <AdvancedMarker position={mapPosition} />
                    <InfoWindow position={mapPosition} maxWidth={200}>
                        <p>
                            <b>
                                Pizzeria La Bruschetta
                            </b>
                        </p>
                        <p>
                            Via V. Alfieri, 52<br/>
                            73040 - Supersano (LE)<br/>
                            Italia
                        </p>
                        <p>
                            <a href='https://www.google.com/maps?ll=40.018437,18.239404&z=18&t=m&hl=it-IT&gl=US&mapclient=apiv3&cid=15507321028079913322' rel='noreferrer' target={"_blank"}>
                                Visualizza su Google Maps
                            </a>
                        </p>

                    </InfoWindow>
                </Map>
            </APIProvider>
        </ScrollAnimation>

        <ScrollAnimation animateIn='fadeIn'>
            <Typography variant='body1' textAlign='left' mt={4} fontWeight='bold'>Pizzeria La Bruschetta</Typography>
            <Typography variant='body1' textAlign='left' fontStyle={'italic'} fontSize='.8rem'>di Daniele De Vitis</Typography>
            <Typography variant='body1' textAlign='left' fontSize='.9rem'>Via V.Alfieri, 52</Typography>
            <Typography variant='body1' textAlign='left' fontSize='.9rem'>73040 - Supersano (LE)</Typography>
            <Typography variant='body1' textAlign='left' fontSize='.9rem'>P.IVA: 04392560753</Typography>
            <Typography variant='body1' textAlign='left' fontSize='.9rem'>CF: DVTDNL88P07B936H</Typography>
        </ScrollAnimation>
        <ScrollAnimation animateIn='fadeIn'>
            <Box pt={3}>
                <a href="https://www.labruschettasupersano.it/OPENDOT.pdf" target='_blank' rel="noreferrer"><Button variant='text'>Rendicontazione erogazioni pubbliche</Button></a>
            </Box>
        </ScrollAnimation>
    </Section>
}

export default Contacts;